var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.59789,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.59789,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    stroke: "#EAEBF0",
    strokeWidth: 0.96934
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3079 35.8146C24.4393 35.8146 25.6382 34.5979 25.6382 32.435C25.6382 30.272 24.4393 29.0554 22.3079 29.0554C20.1765 29.0554 18.9775 30.272 18.9775 32.435C18.9775 34.5979 20.1765 35.8146 22.3079 35.8146Z",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3382 22.9451C25.3293 22.7642 25.3208 22.6171 25.3129 22.4375C25.222 20.3863 24.3946 19.2381 22.3184 19.2381C20.2421 19.2381 19.4147 20.3863 19.3238 22.4375C19.1769 25.7552 18.8453 29.3014 18.9922 32.6191C19.0831 34.6703 20.2705 35.8185 22.3184 35.8185C24.3662 35.8185 25.5536 34.6703 25.6445 32.6191C25.7273 30.7492 25.6581 28.8067 25.5556 26.8734",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1874 35.8146C30.056 35.8146 28.8571 34.5979 28.8571 32.435C28.8571 30.272 30.056 29.0554 32.1874 29.0554C34.3187 29.0554 35.5177 30.272 35.5177 32.435C35.5177 34.5979 34.3187 35.8146 32.1874 35.8146Z",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.157 22.9451C29.166 22.7642 29.1745 22.6171 29.1824 22.4375C29.2732 20.3863 30.1006 19.2381 32.1769 19.2381C34.2532 19.2381 35.0806 20.3863 35.1714 22.4375C35.3184 25.7552 35.65 29.3014 35.503 32.6191C35.4122 34.6703 34.2248 35.8185 32.1769 35.8185C30.129 35.8185 28.9416 34.6703 28.8508 32.6191C28.768 30.7488 28.8372 28.8058 28.9398 26.8721",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9083 23.7333C26.1708 22.1986 28.3096 22.1986 30.5721 23.7333",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViews);
export default __webpack_public_path__ + "static/media/total_views.169478b57f4e7cdb9d62ea1e0e4c7b3d.svg";
export { ForwardRef as ReactComponent };